import { StratificationsFragments } from 'features/drilldown/Stratifications';
import { PoolSummaryFragments } from 'features/loanPool/PoolSummary';

import { gql, useQuery } from '@apollo/client';

import { Filter } from '__generated__/globalTypes';
import {
  GetPoolPerformance,
  GetPoolPerformanceVariables,
} from './__generated__/getPoolPerformance_gql';
export const GET_POOL_PERFORMANCE_QUERY = gql`
  query GetPoolPerformance($poolId: ID!, $filters: [Filter!]) {
    user {
      id
      company {
        id
        pool(id: $poolId) {
          id
          performance_summary(filters: $filters) {
            ...PoolSummaryPerformanceSummary
            ...StratificationsPerformanceSummary
          }
        }
      }
    }
  }
  ${PoolSummaryFragments.performanceSummary}
  ${StratificationsFragments.performanceSummary}
`;

export const usePoolPerformance = (poolId: string | null, filters: Filter[]) => {
  return useQuery<GetPoolPerformance, GetPoolPerformanceVariables>(GET_POOL_PERFORMANCE_QUERY, {
    variables: {
      poolId: poolId!,
      filters,
    },
    skip: !poolId,
    fetchPolicy: 'cache-and-network',
  });
};
